export class Condition {
  private user_input: string | number;
  private case_sensitive: boolean;
  private operator: string;
  observers: Set<() => void>;

  constructor(
    user_input: string | number,
    case_sensitive: boolean,
    operator: string,
  ) {
    this.observers = new Set();
    this.setUserInput(user_input);
    this.setCaseSensitive(case_sensitive);
    this.setOperator(operator);
  }

  getUserInput() {
    return this.user_input;
  }

  getCaseSensitive() {
    return this.case_sensitive;
  }

  getOperator() {
    return this.operator;
  }

  setUserInput(user_input: string | number) {
    this.user_input = user_input;
    this.notifyObservers();
  }

  setCaseSensitive(case_sensitive: boolean) {
    this.case_sensitive = case_sensitive;
  }

  setOperator(operator: string) {
    this.operator = operator;
    this.notifyObservers();
  }

  toJSON() {
    return {
      user_input: this.user_input,
      case_sensitive: this.case_sensitive,
      operator: this.operator,
    };
  }

  addObserver(observer: () => void) {
    this.observers.add(observer);
  }

  removeObserver(observer: () => void) {
    this.observers.delete(observer);
  }

  notifyObservers() {
    this.observers.forEach((observer) => observer());
  }
}
